module.exports = __webpack_public_path__ + "img/icon_cyxm@2x.e3d602af.png";